// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__-jFiO","row":"styles_row__3Lzr3"};